import {FC} from "react";
import {Technologies} from "@components/sections/technologies/technologies";
import ContainerDividerSpanFirst from "@components/dividers/container-divider-span-first";
import {PagePropsBasicType} from "../../../@types/types-body";

const WeLoveTechnology: FC<PagePropsBasicType> = ({namespace}) => {
    return (<section className="my-24">
        <div className="container mx-auto">
            <ContainerDividerSpanFirst
                id={"technology-1"}
                title={"we_love_technology.title"}
                subtitle={"we_love_technology.subtitle"}
                text={"we_love_technology.text"}
                span={"we_love_technology.span"}
                namespace={namespace}
            />
        </div>
        <div className="container mx-auto">
            <Technologies/>
        </div>
    </section>);
};
export default WeLoveTechnology;
